import React from "react";

import { Switch, Route, Redirect, Link } from "react-router-dom";
import axios from 'axios';
// components
import Navbar from "../components/CMS/Navbars/AuthNavbar.js";
import bgImage from "../assets/img/register_bg_2.png";
export default function Auth() {

  async function login() {
    var userName = document.getElementById("userName").value;
    var password = document.getElementById("password").value;

    if (userName == "" || password == "") {
      alert("請輸入你的用戶名稱及密碼！")
    } else {
      const instance = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_LINK,
        headers: {"content-type": "application/json"}
      });

      await instance.post(`/v1/fookchong/cms/login`,{
        username:userName,
        password:password
      }).then(function(response){
        // console.log("res", response);
        // console.log(response.data.data["token"]);
        localStorage.setItem("token", response.data.data["token"]);
        window.location.href = '/cms/admin/project';
      }).catch(function(error){
        alert("登入失敗, 請輸入正確的用戶名稱及密碼！")
      })
      // await fetch(`https://ivelite-dev-env.herokuapp.com/doLogin?username=${userName}&password=${password}`, {
      //   method: "POST",
      //   credentials: 'same-origin',
      //   headers: {
      //     Accept: 'application/json',
      //     'Content-Type': 'application/json'
      //   },
      // })
      //   .then(response => response.json())
      //   .then((usefulData) => {
      //     console.log("login success " + JSON.stringify(usefulData),);
      //     localStorage.setItem("userLogged", true);
      //     window.location.href = '/cms/admin/project';
      //   })
      //   .catch((e) => {
      //     alert("登入失敗, 請輸入正確的用戶名稱及密碼！")
      //   });
    }
  }
  return (
    <>

      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-gray-800 bg-no-repeat bg-full"
            style={{
              backgroundImage: `url(${bgImage})`,
            }}
          ></div>
          <div className="container mx-auto px-4 h-full">
            <div className="flex content-center items-center justify-center h-full">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">

                  <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <div className="text-gray-400 text-center mb-3 font-bold">

                    </div>

                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-gray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        用戶名稱
                      </label>
                      <input
                        id="userName"
                        className="border-0 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="用戶名稱"
                      />
                    </div>

                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-gray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        密碼
                      </label>
                      <input
                        id="password"
                        type="password"
                        className="border-0 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="密碼"
                      />
                    </div>


                    <div className="text-center mt-6">
                      <button
                        className="bg-gray-800 text-white active:bg-gray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        onClick={() => login()}
                      >
                        登入
                      </button>
                    </div>

                  </div>
                </div>
                <div className="flex flex-wrap mt-6 relative">

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
